module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "导入作业结果",
      "width": "45%",
      "visible": _vm.isVisible,
      "before-close": _vm.closeDialog,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.isVisible = $event
      }
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "border": "",
      "data": _vm.importResult
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "jobName",
      "label": "作业名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "success",
      "label": "状态",
      "width": "70px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          attrs: {
            "type": scope.row.success ? 'success' : 'danger'
          }
        }, [_vm._v(_vm._s(_vm.statusMap[scope.row.success]))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "message",
      "label": "失败详情",
      "min-width": "150px"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.closeDialog()
      }
    }
  }, [_vm._v("确认")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-09881883"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/dialog/import_result_dialog.vue
// module id = 1373
// module chunks = 1